import * as React from 'react';
import { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch } from 'react-redux';
import GenericLoader from '../Loader/GenericLoader';
import { TASK_ROW } from '../../pages/Tasks/TaskConstants';
import PaginationComponent from '../../components/Pagination/Pagination';
import './TableComponent.css';
import { TableComponentLoaderAttribute } from '../../constants';

export default function TableComponent({
  loader,
  TableRows,
  TableColumns,
  pageSize,
  totalPage,
  page,
  pageChange,
  handlePageSizeChange,
  customSx = {},
  sortingMode = 'client',
  sortModel,
  onSortModelChange,
  disableColumnFilter = false,
  disableColumnMenu = false,
}) {
  const dispatch = useDispatch();
  // console.log(totalPage,pageNo)
  const [tableHeight, setTableHeight] = useState('auto');
  const rowHeight = 52;
  useEffect(() => {
    const numRows = TableRows.length;
    const calculatedHeight =
      numRows <= 10
        ? numRows == 0
          ? 2.3 * rowHeight
          : (numRows + 1.3) * rowHeight
        : 8.3 * rowHeight;
    setTableHeight(calculatedHeight);
  }, [TableRows]);
  return (
    <>
      {loader ? (
        <GenericLoader rectAttributes={TableComponentLoaderAttribute} />
      ) : (
        <Box sx={{ height: tableHeight, width: '100%' }}>
          <DataGrid
            sx={customSx}
            rows={TableRows}
            autoHeight
            columns={TableColumns}
            pageSize={pageSize}
            rowsPerPageOptions={[5, 10, 25, 50]}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            hideFooter={true}
            sortingMode={sortingMode}
            sortModel={sortModel}
            onSortModelChange={onSortModelChange}
            disableColumnFilter={disableColumnFilter}
            disableColumnMenu={disableColumnMenu}
            onCellClick={(params) =>
              dispatch({
                type: TASK_ROW,
                data: {
                  rowId: params.id,
                },
              })
            }
            components={{
              Pagination: () => null,
            }}
          />

          <Box className="page-holder" sx={{ marginTop: '10px' }}>
            <PaginationComponent
              count={totalPage}
              page={page}
              pageChange={pageChange}
              pageSize={pageSize}
              handlePageSizeChange={handlePageSizeChange}
            />
          </Box>
        </Box>
      )}
    </>
  );
}
